import MemoryGame from "./_modules/memoryGame";
import MemoryGame6 from "./_modules/memoryGame6";
import DifferencesGame from "./_modules/differencesGame";
import PuzzleGame from "./_modules/puzzleGame";
import MemoryGameLAst from './_modules/memoryNewGame';
import RicorsivaPage from './_modules/ricorsivaPage';
import Breeds from "./_modules/breeds";
import Smistamento from "./_modules/smistamento";
import QuizGame from "./_modules/gamefour";
import QuizGameLast from "./_modules/gamefourQuiz";




const App = () => {

	// Run on init

};

document.addEventListener("DOMContentLoaded", () => {
	App();
});

export default App;